import React, { useState, useEffect } from "react";
import { Icon, Icomoon } from "../../brand";

import "./CurrencySelector.scss";

interface Props {
  /** The active currency. */
  currency?: IBaseCurrency;

  /** List of available currencies. */
  currencies?: IBaseCurrency[];

  /**
   * Allow parent to close drop-down. 
   * Should be replaced by refactoring with useClickOutsideHook.
   */
  closeOnMenuClose?: boolean;

  onSelect: (currency: IBaseCurrency) => void;
}

/**
 * Component to display the selected currency, and allow it to be changed via a drop-down list.
 * 
 * @status review
 * - class names should be BEM-style
 */
export const CurrencySelector: React.FC<Props> = (props) => {

  const [visible, setVisible] = useState<boolean>(false);
  useEffect(() => {
    if (props.closeOnMenuClose) {
      setVisible(false);
    }
  }, [props.closeOnMenuClose]);

  const { currency, currencies = [] } = props;

  return (
    <div className="currency-list-wrapper" onClick={() => setVisible(!visible)}>
      <div className="currency-list-header">
        {currency &&
          <img className="currency-flag" src={`/images/flags/currency/${currency.code}.png`} alt={currency.name} />
        }
        <span className="currency-short-name">{currency ? currency.code : ""}</span>
        <Icon className="p-left-xxsmall" icomoon={Icomoon.arrowDown3}/>
      </div>

      {visible &&
        <div className="currency-list">
          {currencies.length !== 0 && currencies.map(c =>
            <div key={`currency_${c.id}`} onClick={() => props.onSelect(c)}>
              <img className="currency-flag" src={`/images/flags/currency/${c.code}.png`} alt={c.name} /> {c.code}
            </div>,
          )}
        </div>
      }
    </div>
  );
}

CurrencySelector.displayName = "CurrencySelector";
